import { getCookie, setCookie } from "./cookies";

export const COOKIE_CONSENT_KEY = "conectadoCookieConsent";
export const COOKIE_CONSENT_VALUE = "accepted";

const CONSENT_MAX_AGE_SECONDS = 60 * 60 * 24 * 365;

export const hasAcceptedCookies = () =>
  getCookie(COOKIE_CONSENT_KEY) === COOKIE_CONSENT_VALUE;

export const acceptCookies = () =>
  setCookie(COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUE, {
    maxAgeSeconds: CONSENT_MAX_AGE_SECONDS,
  });
